import { render, staticRenderFns } from "./AssignBuildingToUser.vue?vue&type=template&id=179d1b48&"
import script from "./AssignBuildingToUser.vue?vue&type=script&lang=js&"
export * from "./AssignBuildingToUser.vue?vue&type=script&lang=js&"
import style0 from "./AssignBuildingToUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports